import { useEffect, useState } from "react";
import { useGetPageQuery } from "../../../redux/services/crmAPI";

const ReportsProducts = () => {
    const [activeStore, setActiveStore] = useState(0);

    const { data: stores } = useGetPageQuery("stores?per_page=200");
    const { data: remainings } = useGetPageQuery("report/remainings?store_id=" + activeStore, { skip: !activeStore });

    useEffect(() => {
        if (stores) {
            setActiveStore(stores.data[0].id);
        }
    }, stores);

    return (
        <>
            {stores && remainings && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Залишки товарів</h1>
                        </div>
                        <div className="pull-right"></div>
                        <div className="row">
                            <div className="col-12">
                                {stores.data.map((store) => {
                                    return (
                                        <div
                                            key={store.id}
                                            className={
                                                activeStore === store.id
                                                    ? "btn btn-info no-print mx-1"
                                                    : "btn btn-primary no-print mx-1"
                                            }
                                            onClick={() => setActiveStore(store.id)}
                                            style={{ marginBottom: "5px" }}
                                        >
                                            {store.title}
                                        </div>
                                    );
                                })}

                                <div className="row">
                                    <div className="col-12 col-sm-6 col-lg-6">
                                        <div className="card card-default">
                                            <div className="card-header">Статистика</div>
                                            <div className="card-body">
                                                <table className="table table-striped">
                                                    <tbody>
                                                        <tr>
                                                            <th>Категорія</th>
                                                            <th>Товари</th>
                                                            <th>Закупка</th>
                                                            <th>Продаж </th>
                                                        </tr>
                                                        {remainings.map((remaining) => {
                                                            return (
                                                                <tr key={remaining.category.id}>
                                                                    <td>{remaining.category.title}</td>
                                                                    <td>{remaining.count}</td>
                                                                    <td>{remaining.purchase}</td>
                                                                    <td>{remaining.sell}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ReportsProducts;
